import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";

class ExchangeEndpoint {
  public rates(
    bank_account_id: string | number,
    to_account_id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    params.params = Object.assign(params.params || {}, {
      bank_account_id,
      to_account_id,
    });

    return $api.get("manager/exchange/rates", params);
  }

  public ratesByCurrency(
    fromCurrency: string,
    toCurrency: string
  ): Promise<AxiosResponse> {
    return $api.get(
      `manager/exchange/rates-by-currency/${fromCurrency}/${toCurrency}`
    );
  }
}

export default ExchangeEndpoint;
